<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Note on Transliteration">
<p class="fmh" id="sec1"><a href="#/text/Contents#rsec1"><b><span class="right_1" epub:type="pagebreak" id="page_ix" title="ix">NOTE ON TRANSLITERATION</span></b></a></p>
<p class="noindent_para"><span class="dropcap">F</span><span class="smallcaps">OR TERMS AND PHRASES IN THE TEXT OF</span> this book, I have used a simplified version of the Library of Congress systems for romanizing Russian, Hebrew, and Yiddish. Most diacritical marks are omitted, and alif and ayin are usually not indicated. For transliterating names, whenever a particular spelling has become somewhat conventional in common English-language usage (outside of academia), I have preferred that romanization over the more technically correct choices. Thus, Chaim Nachman Bialik rather than Hayim Nahman Biyalik. However, in the notes and bibliography, the book titles and names of authors are usually transliterated according to the previously mentioned romanization standard, in order to help scholars who, while able to type Hebrew letters, are not familiar with the Hebrew and Yiddish spellings of these names and titles.<span class="right_1" epub:type="pagebreak" id="page_x" title="x"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter2.vue?5480ddb6